<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Left Column -->
        <div class="footer-column">
          <div class="footer-row flex-wrap flex-xl-nowrap align-items-center">
            <router-link to="/" class="logo-link">
              <h4 class="company-name" :class="logoClass">Sogdo</h4>
            </router-link>
            <span class="tagline-text">{{ companyInfo.tagline }}</span>
            <div class="social-links">
              <a
                v-for="social in socialLinks"
                :key="social.name"
                :href="social.url"
                target="_blank"
                rel="noopener noreferrer"
                class="social-link"
                :title="social.name"
                :style="{
                  background: social.isGradient ? social.bgColor : social.bgColor,
                  borderColor: social.borderColor
                }"
              >
                <svg
                  class="social-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  :style="{ color: social.color }"
                >
                  <path :d="social.icon" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <!-- Middle Column -->
        <div class="footer-column center">
          <!-- <h3 class="connect-title">Lets Connect On:</h3> -->
        </div>

        <!-- Right Column -->
        <div class="footer-column">
          <div class="subscription-container">
            <div class="footer-actions">
              <div 
                v-for="button in actionButtons" 
                :key="button.name"
                class="action-buttons"
              >
                <a 
                  :href="button.url" 
                  class="payment-btn" 
                  :title="button.title"
                  :target="button.isExternal ? '_blank' : '_self'"
                  :rel="button.isExternal ? 'noopener noreferrer' : ''"
                >
                  {{ button.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- Quick Links -->
      <div class="quick-links-section">
        <div class="quick-links">
          <template v-for="(link, index) in quickLinks" :key="link.name">
            <router-link :to="link.path">{{ link.name }}</router-link>
            <span v-if="index < quickLinks.length - 1" class="separator">|</span>
          </template>
        </div>
      </div>

      <!-- Legal Info -->
      <div class="legal-info-bar">
        <span>CIN: {{ companyInfo.cin }}</span>
        <span>{{ companyInfo.copyright }}</span>
        <span>{{ companyInfo.registration }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      socialLinks: [
        {
          name: 'LinkedIn',
          url: 'https://www.linkedin.com/company/sogdo',
          icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
          color: '#0077b5',
          bgColor: 'rgba(0, 119, 181, 0.2)',
          borderColor: '#0077b5'
        },
        {
          name: 'YouTube',
          url: 'https://www.youtube.com/@sogdo',
          icon: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
          color: '#ff0000',
          bgColor: 'rgba(255, 0, 0, 0.2)',
          borderColor: '#ff0000'
        },
        {
          name: 'WhatsApp',
          url: 'https://wa.me/918000090590',
          icon: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488',
          color: '#25d366',
          bgColor: 'rgba(37, 211, 102, 0.2)',
          borderColor: '#25d366'
        },
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/people/Sogdo/61571149624256/',
          icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
          color: '#1877f2',
          bgColor: 'rgba(24, 119, 242, 0.2)',
          borderColor: '#1877f2'
        },
        {
          name: 'Instagram',
          url: 'https://www.instagram.com/sogdo_official/',
          icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
          color: '#ffffff',
          bgColor: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
          borderColor: 'transparent',
          isGradient: true
        }
      ],
      quickLinks: [
        { name: 'About', path: '/about' },
        { name: 'Contact', path: '/contact' },
        { name: 'Careers', path: '/careers' },
        { name: 'Our Presence', path: '/presence' },
        { name: 'FAQs', path: '/faqs' },
        { name: 'Terms & Conditions', path: '/terms' },
        { name: 'Payment Policy', path: '/payment-policy' },
        { name: 'Privacy Policy', path: '/privacy' },
        { name: 'Refund Policy', path: '/refund-policy' }
      ],
      actionButtons: [
        { 
          name: 'Payment', 
          url: '#', 
          title: 'Coming Soon',
          isExternal: false
        },
        { 
          name: 'Refund', 
          url: 'mailto:refund@sogdo.in?subject=Refund Request', 
          title: 'Coming Soon',
          isExternal: true
        }
      ],
      companyInfo: {
        tagline: 'Innovative, Empowering, Multi-Sectoral, Human-Centric, Progressive',
        cin: 'U72200KA2024PTC123456',
        copyright: '©2024-2034 Sogdo. All rights reserved.',
        registration: 'Registered under Companies Act, 2013'
      }
    }
  },
  computed: {
    isHomePage() {
      return this.$route.path === "/";
    },
    logoClass() {
      return {
        gradient: this.isHomePage,
        white: !this.isHomePage,
      };
    },
  },
};
</script>

<style scoped>
.footer {
  background: linear-gradient(to right, #000000, #0b2b3c);
  color: #ffffff;
  padding: 3rem 2rem;
}

.footer-content {
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.footer-column.center {
  align-items: center;
  justify-content: flex-start;
}

.company-name {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
}

.company-name.gradient {
  background: linear-gradient(to right, #8a2be2, #e91e63);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.company-name.white {
  color: #ffffff;
}

.company-tagline {
  font-size: 1.2rem;
  line-height: 1.5;
  margin: 0;
  color: #ffffff;
}

.connect-title {
  font-size: 1.4rem;
  margin: 0;
  color: #ffffff;
  font-weight: 500;
}

.social-links {
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
}

.social-link {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.social-link:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.social-icon {
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
}

.social-link:hover .social-icon {
  transform: scale(1.1);
}

/* LinkedIn - Professional Blue */
.social-link[title="LinkedIn"] {
  background: rgba(0, 119, 181, 0.2);
  border: 1px solid #0077b5;
}

.social-link[title="LinkedIn"] .social-icon {
  color: #0077b5;
}

.social-link[title="LinkedIn"]:hover {
  background: rgba(0, 119, 181, 0.3);
  border-color: #0077b5;
  box-shadow: 0 5px 15px rgba(0, 119, 181, 0.4);
}

/* YouTube - Red */
.social-link[title="YouTube"] {
  background: rgba(255, 0, 0, 0.2);
  border: 1px solid #ff0000;
}

.social-link[title="YouTube"] .social-icon {
  color: #ff0000;
}

.social-link[title="YouTube"]:hover {
  background: rgba(255, 0, 0, 0.3);
  border-color: #ff0000;
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
}

/* WhatsApp - Green */
.social-link[title="WhatsApp"] {
  background: rgba(37, 211, 102, 0.2);
  border: 1px solid #25d366;
}

.social-link[title="WhatsApp"] .social-icon {
  color: #25d366;
}

.social-link[title="WhatsApp"]:hover {
  background: rgba(37, 211, 102, 0.3);
  border-color: #25d366;
  box-shadow: 0 5px 15px rgba(37, 211, 102, 0.4);
}

/* Facebook - Blue */
.social-link[title="Facebook"] {
  background: rgba(24, 119, 242, 0.2);
  border: 1px solid #1877f2;
}

.social-link[title="Facebook"] .social-icon {
  color: #1877f2;
}

.social-link[title="Facebook"]:hover {
  background: rgba(24, 119, 242, 0.3);
  border-color: #1877f2;
  box-shadow: 0 5px 15px rgba(24, 119, 242, 0.4);
}

/* Instagram - Gradient */
.social-link[title="Instagram"] {
  background: linear-gradient(
    45deg,
    #f09433 0%,
    #e6683c 25%,
    #dc2743 50%,
    #cc2366 75%,
    #bc1888 100%
  );
  border: 1px solid transparent;
}

.social-link[title="Instagram"] .social-icon {
  color: #ffffff;
}

.social-link[title="Instagram"]:hover {
  background: linear-gradient(
    45deg,
    #f09433 0%,
    #e6683c 25%,
    #dc2743 50%,
    #cc2366 75%,
    #bc1888 100%
  );
  box-shadow: 0 5px 15px rgba(188, 24, 136, 0.4);
}


.subscription-container p {
  font-size: 1rem;
  margin: 0.5rem 0 1rem 0;
  color: #ffffff;
  opacity: 0.8;
}

.subscription-form {
  display: flex;
  gap: 0.5rem;
  min-width: 300px;
}

.email-input {
  flex: 1;
  padding: 0.3rem 0.5rem; /* Further reduced padding */
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 3px; /* Slightly smaller border radius */
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  font-size: 0.75rem; /* Smaller font size */
  width: 40%; /* Reduced width */
  min-width: 80px; /* Ensuring it doesn't become too small */
  transition: all 0.3s ease;
}

.email-input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.15);
}

.email-input::placeholder {
  color: rgba(6, 8, 16, 0.6);
}

.payment-btn {
  padding: 0.75rem 1.5rem;
  height: 42px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
}

.payment-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.subscribe-btn {
  padding: 0.75rem 1.5rem;
  height: 42px;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.subscribe-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.quick-links-section {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem 0;
  margin: 2rem 0;
}

.quick-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.quick-links a {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.quick-links a:hover {
  color: #e91e63;
}

.separator {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 300;
}

.legal-info-bar {
  color: #ffffff;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.legal-info-bar span {
  white-space: nowrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  padding-bottom: 2px;
}

.footer-actions {
  display: flex;
  align-items: center;
  gap: 2rem;
  width: 100%;
  justify-content: space-between;
}

.logo-link {
  text-decoration: none;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 1px;
}

.logo-link:hover {
  opacity: 0.8;
}

.social-links {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.payment-btn {
  padding: 0.75rem 1.5rem;
  height: 42px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
}

.payment-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.subscribe-btn {
  padding: 0.75rem 1.5rem;
  height: 42px;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.subscribe-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.subscription-form {
  display: flex;
  gap: 0.5rem;
  min-width: 300px;
}

.email-input {
  height: 42px;
}

.tagline-text {
  color: #ffffff;
  font-size: 0.9rem;
  margin: 0 1rem;
  opacity: 0.9;
  white-space: nowrap;
}

.footer-row {
  display: flex;
  align-items: center;
  gap: 2rem;
  width: 100%;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-column {
    align-items: center;
  }

  .footer-actions {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .logo-link {
    margin-bottom: 1rem;
  }

  .social-links {
    justify-content: center;
  }

  .payment-btn {
    width: 100%;
  }

  .subscription-form {
    width: 100%;
  }

  .quick-links {
    flex-direction: column;
    align-items: center;
  }

  .separator {
    display: none;
  }

  .legal-info-bar {
    flex-direction: column;
    gap: 0.8rem;
    text-align: center;
    padding: 16px;
  }

  .legal-info-bar span {
    display: inline-block;
  }

  .footer-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
  }

  .tagline-text {
    margin: 0.5rem 0;
    white-space: normal;
    text-align: center;
  }
}
</style> 